import { useEffect, useState } from "react";
import {
  Spinner,
  Card,
  CardBody,
  Col,
  Button,
  CardHeader,
  Row,
  FloatingLabel,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Container,
} from "react-bootstrap";
import {
  BASEURL,
  CUSTOMERID,
  GET_ALL_SAVED_CARD_DETAILS,
  GetCustomerId,
} from "../../CONSTANTS";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useScreenSize, useCustomScreen } from "../../Components/Utils";
import toast from "react-hot-toast";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OrderHistory = () => {
  const [allCards, setAllCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [error, setError] = useState("");
  const [cardType, setCardType] = useState("");
  const [isCardDefault, setIsCardDefault] = useState(false);
  const [cardName, setCardName] = useState("");
  const [cardExpirationDetails, setCardExpirationDetails] = useState("");
  const [defaultCardNumber, setDefaultCardNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [changeCardLoading, setChanegCardLoading] = useState(false);
  const [invalidExpiry, setInValidExpiry] = useState(false);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  const tokenFromCookies = Cookies.get("token");

  const decodedToken = Cookies.get("decodedToken"); // Get raw cookie value
  const parsedToken = decodedToken ? JSON.parse(decodedToken) : null; // Parse only if exists

  const customerIdFromCookies = parsedToken ? parsedToken.customerid : null;
  const userIdFromCookies = parsedToken ? parsedToken.unique_name : null;

  const USERID = window.localStorage.getItem("userId") || userIdFromCookies;
  const customerId =
    window.localStorage.getItem("customerId") || customerIdFromCookies;
  const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;

  const navigate = useNavigate();
  useEffect(() => {
    savedCards();
  }, []);
  const savedCards = async (showLoading = true) => {
    try {
      if (showLoading) setLoading(true);
      const response = await fetch(
        `${GET_ALL_SAVED_CARD_DETAILS}/${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        }
      );
      if (response.ok) {
        const result = await response.json();

        let tempRes = result["paymentCards"];
        tempRes.map((r, rInx) => {
          if ("isDefault" in r) {
            if (r["isDefault"]) {
              "paymentCardId" in r && setSelectedCard(r);
              "cardNumber" in r && setDefaultCardNumber(r["cardNumber"]);
            }
          }
        });
        setAllCards([...result["paymentCards"]]);
      } else {
        console.error("Failed to fetch data");
      }
    } catch (e) {
      if (e.status === 401) {
        navigate("/login");
      }
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  const saveChangedDefaultCard = async () => {
    const response = await fetch(
      `${BASEURL}paymentcards/${CUSTOMERID}/true/${selectedCard?.paymentCardId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
        },
      }
    );
    if (response) {
      // const result = await response.json();
      // handleCardPopupClose();
    } else {
      console.log("failed to update card");
    }
  };

  const clearFields = () => {
    setCardName("");
    setCardNumber("");
    setCardType("");
    setIsCardDefault(false);
    setCardExpirationDetails("");
  };

  const deleteSavedCard = async (selCard) => {
    // http://apiqa.rooftopmeasurements.com/paymentcards/delete-card/{PaymentCardId}/{VaultId}
    setAllCards((prevCards) =>
      prevCards.filter((card) => card.paymentCardId !== selCard.paymentCardId)
    );
    try {
      const response = await fetch(
        `${BASEURL}paymentcards/delete-card/${selCard?.paymentCardId}/${selCard?.vaultId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
          },
        }
      );
      if (response.ok) {
        clearFields();
        savedCards(false);
      } else {
        toast.error("Failed to delete card", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
        savedCards();
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    }
  };

  const changePrimaryCard = async (e, selIndex) => {
    let tempAllCards = allCards.length > 0 ? [...allCards] : [];
    if (tempAllCards.length && tempAllCards.length >= selIndex) {
      let selCard = tempAllCards[selIndex];
      selCard["isDefault"] = true;
      setSelectedCard(selCard);
      try {
        setChanegCardLoading(!changeCardLoading);
        const response = await fetch(
          `${BASEURL}paymentcards/${CUSTOMERID}/true/${selCard.paymentCardId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
            },
          }
        );

        tempAllCards[selIndex] = selCard;
        if (response) {
          savedCards();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setChanegCardLoading(false);
      }
    }
    setAllCards([...tempAllCards]);
  };

  const makeCardDefault = () => {
    setIsCardDefault(true);
  };
  const changeCardNameHandler = (e) => {
    setCardName(e.target.value);
  };

  const changeCardExpirationDetails = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    // Ensure the input doesn't exceed 4 digits
    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    // Format the value as MM/YY
    if (value.length > 2) {
      value = value.substring(0, 2) + "/" + value.substring(2, 4);
    }

    // Validate expiry date
    if (value.length === 5) {
      // MM/YY format has 5 characters including the slash
      const [month, year] = value.split("/").map(Number);

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JS months are 0-based
      const currentYear = currentDate.getFullYear() % 100; // Get last 2 digits of year

      if (
        year < currentYear ||
        (year === currentYear && month < currentMonth) ||
        month < 1 ||
        month > 12
      ) {
        setInValidExpiry(true);
      } else {
        setInValidExpiry(false);
      }
    } else {
      setInValidExpiry(false);
    }

    // Update the state with the formatted value
    setCardExpirationDetails(value);
  };

  const handleBackspace = (e) => {
    if (e.key === "Backspace" && cardExpirationDetails.length <= 3) {
      setCardExpirationDetails("");
    }
  };

  //  const isSaveDisabled =
  //   !cardName.trim() ||
  //   !cardNumber.replace(/\s/g, "") ||
  //   cardNumber.replace(/\s/g, "").length !== 16 ||
  //   !cardExpirationDetails ||
  //   cardExpirationDetails.length !== 5 ||
  //   invalidExpiry ||
  //   !!error;

  const saveCardHandler = async () => {
    if (!cardName || !cardNumber || !cardExpirationDetails) return;
    const [expMonth, expYear] = cardExpirationDetails.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;
    console.log("customerid", CUSTOMERID);
    const tempCardNumber = cardNumber
      ? String(cardNumber).replaceAll(" ", "")
      : "";
    let res = {
      customerId: GetCustomerId(),
      expMonth: `${expMonth}`,
      expYear: `${expiry}`,
      cardName: `${cardName}`,
      cardNumber: `${tempCardNumber}`,
      isDefault: isCardDefault,
      paypalCustomerId: "",
    };
    if (allCards.length >= 5) {
      toast.error("Cannot Add more than 5 cards", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
      setCardName("");
      setCardNumber("");
      setCardType("");
      setIsCardDefault(false);
      setCardExpirationDetails("");
      return;
    }
    // let optimesticUpdateObj = {
    //   customerId: `${CUSTOMERID}`,
    //   expMonth: `${expMonth}`,
    //   expYear: `${expiry}`,
    //   cardName: `${cardName}`,
    //   cardNumber: `${tempCardNumber}`,
    //   isDefault: isCardDefault,
    //   paypalCustomerId: "",
    // };
    // setAllCards((prevCards) => [...prevCards, optimesticUpdateObj]);
    try {
      setLoading(true);
      const response = await fetch(`${BASEURL}paymentcards/add-card`, {
        method: "POST",
        body: JSON.stringify(res),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
        },
      });
      const result = await response.json();
      if (response.ok) {
        savedCards();
        clearFields();
      } else {
        toast.error(result.message, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      }
      //  else {
      //   savedCards();
      // }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
    // handleCardPopupClose();
  };

  const handleChange = (event) => {
    let input = event.target.value;

    // Remove non-digit characters
    input = input.replace(/\D/g, "");

    // Limit the card number to 16-19 digits
    if (input.length > 19) {
      input = input.slice(0, 19);
    }

    // Format the card number (e.g., 1234 5678 9012 3456)
    const formattedInput = input.match(/.{1,4}/g)?.join(" ") || input;

    setCardNumber(formattedInput);

    if (formattedInput) {
      // Identify card type
      const detectedCardType = getCardType(input);
      setCardType(detectedCardType);
    } else {
      setCardType("");
    }

    // Validate using Luhn algorithm
    if (input.length < 16) {
      const isValid = isValidCardNumber(input);
      setError(isValid ? "" : "Invalid card number");
    } else {
      setError("");
    }
  };

  const getCardType = (cardNumber) => {
    const patterns = {
      visa: /^4[0-9]{0,}$/, // Visa starts with 4
      mastercard: /^(5[1-5]|2[2-7])/, // Mastercard starts with 51-55 or 22-27
      amex: /^3[47]/, // American Express starts with 34 or 37
      discover: /^6(?:011|5[0-9]{2})/, // Discover starts with 6011 or 65
      maestro: /^(5018|5020|5038|56|57|58|6304|6759|676[1-3])/, // Maestro
      diners: /^(3(0[0-5]|[68]|9)|5[4])\d{0,}$/, // Diners Club
    };

    for (const [cardType, pattern] of Object.entries(patterns)) {
      if (pattern.test(cardNumber)) {
        return cardType;
      }
    }
    return "unknown";
  };

  const rawCardNumber = cardNumber.replace(/\s/g, "");
  const detectedCardType = getCardType(rawCardNumber);
  const validCardLengths = {
    visa: [16],
    mastercard: [16],
    amex: [15],
    discover: [16],
    diners: [14, 15, 16], // [14, 15, 16]
    maestro: [12, 13, 14, 15, 16, 17, 18, 19], // [12–19]
  };

  const isCardLengthValid =
    rawCardNumber.length >= 12 &&
    validCardLengths[detectedCardType]?.includes(rawCardNumber.length);

  const isSaveDisabled =
    !cardName.trim() ||
    !rawCardNumber ||
    !cardExpirationDetails ||
    cardExpirationDetails.length !== 5 ||
    invalidExpiry ||
    !!error ||
    !isCardLengthValid;

  const isValidCardNumber = (cardNumber) => {
    const digits = cardNumber.replace(/\D/g, ""); // Remove non-digit characters
    let sum = 0;
    let shouldDouble = false;

    // Loop through the digits from right to left
    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = parseInt(digits[i], 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  return (
    <>
      {loading ? (
        <Container
          style={{ height: "100vh" }}
          className="w-100% d-flex justify-content-center align-items-center"
        >
          <Spinner animation="border" role="status"></Spinner>
        </Container>
      ) : (
        <div className="">
          <h5
            className="mt-3"
            style={{
              backgroundColor: "lightblue",
              padding: "1em",
              width: "100%",
              fontSize: is4kScreen
                ? "2rem"
                : isXxlScreen
                ? "1.4rem"
                : isXlScreen
                ? "1.2rem"
                : isIpadProPortrait
                ? "1.95rem"
                : isLargeScreen
                ? ""
                : isMediumScreen
                ? "1.7rem"
                : "",
            }}
          >
            <b>Billing Details</b>
          </h5>
          <hr></hr>
          <h6
            className="mt-2 "
            style={{
              fontSize: is4kScreen
                ? "1.6rem"
                : isIpadProPortrait
                ? "1.6rem"
                : isMediumScreen
                ? "1.3rem"
                : "",
            }}
          >
            <b>Add Card</b>
          </h6>
          <Form style={{ padding: "0px 2em" }}>
            <Form.Group
              className="mb-3 row align-items-center"
              controlId="cardName"
            >
              <Form.Label
                className="col-4 col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Card Name:
              </Form.Label>

              <div className="col-8 col-md-5 col-12 credits-purchase">
                <Form.Control
                  className="col-md-7"
                  placeholder="Card Name"
                  value={cardName}
                  onChange={(e) => changeCardNameHandler(e)}
                  type="text"
                  style={{ fontSize: isMediumScreen ? "1.3rem" : "" }}
                />
              </div>
            </Form.Group>
            <Form.Group
              className="mb-3 row align-items-center"
              controlId="cardNumber"
            >
              <Form.Label
                className="col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Card Number:
              </Form.Label>

              <div className="col-md-5 col-12 credits-purchase">
                <input
                  type="text"
                  className="col-md-5 form-control"
                  id="cardNumber"
                  value={cardNumber}
                  onChange={handleChange}
                  placeholder="1234 5678 9012 3456"
                  maxLength="19"
                  style={{ fontSize: isMediumScreen ? "1.3rem" : "" }}
                />
              </div>
            </Form.Group>

            {error ? (
              <Form.Group
                className="mb-3 row align-items-center"
                controlId="cardName"
              >
                <Form.Label
                  className="col-4 col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                  style={{ fontSize: is4kScreen ? "1.7rem" : "" }}
                ></Form.Label>

                <div className="col-8 col-md-5 col-12 credits-purchase">
                  <p
                    style={{
                      color: "red",
                      fontSize: is4kScreen ? "1.7rem" : "",
                    }}
                  >
                    {error}
                  </p>
                </div>
              </Form.Group>
            ) : null}

            {cardType && !error ? (
              <Form.Group
                className="row align-items-center"
                controlId="cardName"
              >
                <Form.Label
                  className="col-4 col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isIpadProPortrait
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : "",
                  }}
                >
                  Card Type:
                </Form.Label>

                <div className="col-8 col-md-5 col-12 credits-purchase">
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.7rem"
                        : isMediumScreen
                        ? "1.3rem"
                        : "",
                    }}
                  >
                    <strong>{cardType.toUpperCase()}</strong>
                  </p>
                </div>
              </Form.Group>
            ) : null}

            <Form.Group
              className="mb-2 row align-items-center"
              controlId="expiryDate"
            >
              <Form.Label
                className="col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Expiration Month/Year:
              </Form.Label>

              <div className="col-md-5 col-12 credits-purchase">
                <Form.Control
                  placeholder="MM/YY"
                  type="text"
                  value={cardExpirationDetails}
                  onChange={(e) => changeCardExpirationDetails(e)}
                  onKeyDown={handleBackspace}
                  maxLength={7}
                  style={{ fontSize: isMediumScreen ? "1.3rem" : "" }}
                />
              </div>
            </Form.Group>

            {invalidExpiry ? (
              <Form.Group
                className="mb-3 row align-items-center"
                controlId="cardName"
              >
                <Form.Label
                  className="col-4 col-md-5 col-12 mb-2 mb-md-0 text-md-center text-sm-start"
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isIpadProPortrait
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : "",
                  }}
                ></Form.Label>

                <div className="col-8 col-md-5 col-12 credits-purchase">
                  <p
                    className="text-danger"
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.7rem"
                        : isMediumScreen
                        ? "1.3rem"
                        : "",
                    }}
                  >
                    Invalid Expiry details
                  </p>
                </div>
              </Form.Group>
            ) : null}

            <Form.Group
              className="mb-2 row align-items-center"
              controlId="expiryDate"
            >
              <Form.Label className="col-md-5 col-12 mb-2 mb-md-0 text-center"></Form.Label>

              <div className="col-md-5 col-12">
                <Form.Group controlId="Make Default" className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Make this Primary"
                    checked={isCardDefault}
                    onChange={(e) => setIsCardDefault(e.target.checked)}
                    style={{
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.7rem"
                        : isMediumScreen
                        ? "1.3rem"
                        : "",
                    }}
                  />
                </Form.Group>
              </div>
            </Form.Group>
          </Form>
          <br></br>
          <Row>
            <Col className="d-flex justify-content-center align-items-center">
              <Button
                className="login-btns btn mb-3 col-sm-3"
                type="submit"
                disabled={isSaveDisabled}
                onClick={() => saveCardHandler()}
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
                // onClick={() => navigate("/signup")}
              >
                Save
              </Button>
            </Col>
          </Row>
          <hr></hr>
          <h6
            className="mb-3 mt-3"
            style={{
              fontSize: is4kScreen
                ? "1.6rem"
                : isIpadProPortrait
                ? "1.6rem"
                : isMediumScreen
                ? "1.3rem"
                : "",
            }}
          >
            <b>Card Details</b>
          </h6>
          <Container fluid>
            {/* Header Row */}
            <Row className=" d-none d-sm-flex">
              <Col sm={3} className="">
                <strong
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : "",
                  }}
                >
                  Card Number
                </strong>
              </Col>
              <Col sm={4} className="">
                <strong
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : "",
                  }}
                >
                  Expiration Date
                </strong>
              </Col>
              <Col sm={3} className=" text-center">
                <strong
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : "",
                  }}
                >
                  Is Primary?
                </strong>
              </Col>
              <Col sm={2} className=" text-danger text-center">
                {/* <strong>Action</strong> */}
              </Col>
            </Row>

            {/* Cards Data */}
            {allCards.length > 0 &&
              allCards.map((card, cInx) => (
                <Row
                  key={cInx}
                  className="border-bottom py-2 align-items-center"
                >
                  {/* Card Number */}
                  <Col xs={12} sm={3} className="mb-1 mb-sm-0">
                    <strong className="d-sm-none">Card Number:</strong>{" "}
                    <strong
                      style={{
                        fontSize: is4kScreen
                          ? "1.7rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                      }}
                    >
                      {card?.cardNumber}
                    </strong>
                  </Col>

                  {/* Expiration Date */}
                  <Col xs={12} sm={4} className="mb-2 mb-sm-0">
                    <strong className="d-sm-none">Expiration Date:</strong>{" "}
                    <strong
                      style={{
                        fontSize: is4kScreen
                          ? "1.7rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                      }}
                    >
                      {card?.cardExpiry}
                    </strong>
                  </Col>

                  {/* Is Primary */}
                  <Col
                    xs={12}
                    sm={3}
                    className="d-flex align-items-center gap-1 justify-content-sm-evenly mb-2 mb-sm-0"
                  >
                    <strong className="d-sm-none">Set Default</strong>
                    <input
                      className="m-sm-2"
                      type="radio"
                      value={card?.isDefault}
                      checked={
                        card?.paymentCardId === selectedCard.paymentCardId
                      }
                      onChange={(e) => changePrimaryCard(e, cInx)}
                      style={{
                        width: is4kScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.3rem"
                          : "",
                        height: is4kScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.3rem"
                          : "",
                      }}
                    />
                  </Col>

                  {/* Delete Option */}
                  <Col xs={12} sm={2} className="text-danger text-sm-end">
                    <span
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: is4kScreen
                          ? "1.7rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : "",
                      }}
                      onClick={() => deleteSavedCard(card)}
                    >
                      Delete
                    </span>
                  </Col>
                </Row>
              ))}
          </Container>

          {/* {allCards.length > 0 && (
            <Row>
              <Col className="d-flex justify-content-center align-items-center">
                <Button
                  className="login-btns btn mb-3 mt-3 col-sm-3"
                  type="submit"
                  onClick={(e) => {
                    saveChangedDefaultCard(e);
                  }}
                >
                  Save
                </Button>
              </Col>
            </Row>
          )} */}
        </div>
      )}
    </>
  );
};
export default OrderHistory;
